import React from "react";
import "./ForMen.css"; // existing CSS untouched
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

/* 🔥 REQUIRED IMPORTS */
import products from "../../data/products";
import ReviewSlider from "../ReviewSlider";
import FeaturesSection from "../FeaturesSection";
import BlogSection from "../BlogPage";

const ForWomen = () => {
  const womenProducts = products.filter((item) => item.category === "women");

  return (
    <>
      <Helmet>
        <title>
          Buy Women Pleasure Products Online in India | Discreet Delivery – LushDesire
        </title>

        <meta
          name="description"
          content="Shop women pleasure products online in India. Buy dildos, vibrators, butt plugs, BDSM kits & accessories with 100% discreet delivery from LushDesire."
        />

        <link rel="canonical" href="https://lushdesire.in/women" />
      </Helmet>

      <section className="men-page">
        <div className="container">
          {/* ✅ H1: Page Title */}
          <h1 className="men-title">Premium Pleasure Products for Women in India</h1>

          {/* ✅ H2: Intro Paragraph */}
       <div style={{ textAlign: "center", marginBottom: "30px" }}>
  {/* ✅ H2: Intro */}
  <h2 className="section-subtitle" style={{ fontWeight: "600", fontSize: "1.6rem" }}>
    Shop Dildos, Vibrators, Butt Plugs & BDSM Kits in India
  </h2>

  {/* ✅ H3: Short SEO tagline */}
  <h3 className="section-subtitle" style={{ fontWeight: "400", fontSize: "1.2rem", color: "#555" }}>
    Premium Women Sex Toys & Accessories with Discreet Delivery
  </h3>
</div>


          <div className="men-grid">
            {womenProducts.map((item) => (
              <div className="men-card" key={item.id}>
                <img
                  src={process.env.PUBLIC_URL + item.image}
                  alt={`${item.name} for women with discreet delivery in India`}
                  loading="lazy"
                />

                {/* ✅ H4: Individual Product Name */}
                <h4 className="product-name">{item.name}</h4>

                <div className="price-box">
                  <span className="mrp">₹{item.mrp}</span>
                  <span className="price">₹{item.price}</span>
                </div>

                <Link
                  to={`/product/${item.slug || item.id}`}
                  className="order-btn"
                >
                  Order Now
                </Link>

                {/* ✅ H5: Short SEO description per product */}
                <h5 style={{ fontSize: "0.9rem", marginTop: "5px", color: "#555" }}>
                  Buy {item.name} online in India. Discreet packaging & fast delivery.
                </h5>
              </div>
            ))}
          </div>

          {/* SAFETY CHECK */}
          {womenProducts.length === 0 && (
            <p style={{ textAlign: "center" }}>
              No products found for women.
            </p>
          )}
        </div>
      </section>

      <FeaturesSection />
      <ReviewSlider />
      <BlogSection />
    </>
  );
};

export default ForWomen;
